import React from 'react'
import { Layout } from '../../components'
import ForgotPassword from '../../views/ForgotPassword/ForgotPassword'

const Index = () => {
  return <ForgotPassword />
}

Index.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

export default Index
